function ProbChartBox(){return/*#__PURE__*/React.createElement("div",{id:"pool-box"},"Prob Chart Box");}export default ProbChartBox;